module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2UlEQVQ4T53TMU4CQRQG4I9EOksLD0DBIbCw9BZewMSCUkJhQ2JjQekBvIGljYcw4QByADpIJI+Mm9ndWYSdbue9/5vM7MwAL3jEhfpY4x0zbBq16nOAbSGc93/jFgG2RgC/afYBSzzjqdHZieTAEDuMsCosVkRyYIG3tPp9x55bSA50nVNzvoYE8IPrU9Opr0ICiN84PROI9kBuArjEByY9kGUAMfoir39AH+QLdzlwDnIIxxVvAqcgVTiaS8AxpBY+BkQt7sYnxumgW+H/gKhfYZ7eSPFZ7wG9pjJTIW7qfwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/teamproject/biaoqian.png
// module id = SYnX
// module chunks = 1